import React, { Component } from 'react';
import {connect} from 'react-redux';
import  Button  from 'react-bootstrap-button-loader';
import ProcessReset from './process.js';

class ProcessResetPassword extends Component {

  constructor(props){
  	super(props);
    this.state = { loading:false};

  }

  componentWillMount(){

  }

  render(){
      return (
          <div style={{background:'#3f4458'}}>
            <div className="text-center template-container">
                <ProcessReset {...this.props}/>
            </div>
          </div>
      );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user
  };
}

export default connect(mapStateToProps,null)(ProcessResetPassword);
